






















import {
  defineComponent,
  computed,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { faTimesCircle, faEraser } from '@fortawesome/free-solid-svg-icons'
import { CategoryId } from '~/models/category/types'

export default defineComponent({
  props: {
    hasThirdLevelSubcategories: {
      type: Boolean,
      default: false
    },
    isPartsSection: {
      type: Boolean,
      default: false
    },
    isBicycleSection: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const {
      hasThirdLevelSubcategories,
      isPartsSection,
      isBicycleSection
    } = toRefs(props)
    const { getters, dispatch } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )

    const isPc = computed(() => userAgentGetters('isPc'))
    const facetsCount = computed(() => getters('getFacetsCount'))
    const getCurrentCategory = computed(() => {
      // Special filtering in getter for removing categoryIDs that add to overall array length causing bugs in the computed logic for toggling the visibility of the clear handler btn
      return getters('getCurrentCategory').filter(
        (cat: number) =>
          ![
            CategoryId.PARTS,
            CategoryId.VEHICLES,
            CategoryId.HOBBIES,
            CategoryId.COMMERCIAL
          ].includes(cat)
      )
    })
    const getSelectedFacets = computed(() => getters('getSelectedFacets'))

    const showHandler = computed(() => {
      if (
        (getCurrentCategory.value.length > 1 || facetsCount.value > 0) &&
        !hasThirdLevelSubcategories.value &&
        !isPartsSection.value &&
        !isBicycleSection.value
      ) {
        return true
      }
      if (
        (getCurrentCategory.value.length > 1 ||
          getSelectedFacets.value.length > 1 ||
          facetsCount.value > 0) &&
        !hasThirdLevelSubcategories.value &&
        isPartsSection.value
      ) {
        return true
      }
      if (
        (getCurrentCategory.value.length > 1 ||
          getSelectedFacets.value.length > 1 ||
          facetsCount.value > 1) &&
        (hasThirdLevelSubcategories.value || isBicycleSection.value)
      ) {
        return true
      }
      return false
    })

    watch(showHandler, () => {
      showHandler.value
        ? emit('show-mobile-clear-button', true)
        : emit('hide-mobile-clear-button', false)
    })

    const icons = {
      clear: faTimesCircle,
      clearMobile: faEraser
    }

    const handleClear = () => {
      dispatch('clearAll')
    }

    return {
      icons,
      facetsCount,
      handleClear,
      isPc,
      getCurrentCategory,
      getSelectedFacets,
      showHandler
    }
  }
})
